import React from "react";
import { createRoot } from "react-dom/client";
import brandStory from "./img/brandStory.jpg";

const App = () => {
  return (
    <>
      <img src={brandStory} />
    </>
  );
};

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
